


















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'LfsTextBox',

  model: {
    prop: 'value',
    event: 'input'
  }
})
export default class LfsSelectBox extends Vue {
  @Prop(String) header!: string
  @Prop({
    type: String,
    default: ''
  })
  value!: string
  @Prop(String) placeholder!: string

  handleChange (text: string): void {
    this.$emit('input', text)
    this.$emit('changedQuestion')
  }
}
